import { apiUrl } from "../utils/apiUrl";

export function playerIdentity(user) {
  const userId = String(user?.userId || user?.id || "").trim();
  const fromName = String(user?.name || "").trim().split(/\s+/)[0] || "";
  const firstName = String(user?.firstName || fromName).trim();
  return { userId, firstName };
}

export async function postGame(path, token, body) {
  const response = await fetch(apiUrl(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body || {}),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (response.status === 401) {
    const error = new Error("Session expired");
    error.status = 401;
    throw error;
  }

  if (!response.ok || data.success === false) {
    const error = new Error(data.message || data.error || "Request failed");
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function uploadGameImage({ token, currentTheme, target, file }) {
  const body = new FormData();
  body.append("file", file);
  body.append("currentTheme", currentTheme);
  body.append("target", target);

  const response = await fetch(apiUrl("/uploadGameImage"), {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body,
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (response.status === 401) {
    const error = new Error("Session expired");
    error.status = 401;
    throw error;
  }
  if (!response.ok || data.success === false) {
    const error = new Error(data.error || data.message || "Could not upload image");
    error.status = response.status;
    throw error;
  }
  return data;
}
